import PropTypes from 'prop-types';
import SVG from '@activebrands/core-web/components/SVG';

const EditIcon = ({ color = 'currentColor', width = '12px', height = 'auto', $style = {}, ...rest }) => {
    const style = { width, height, ...$style };

    return (
        <SVG $style={style} fill="none" viewBox="0 0 12 12" {...rest}>
            <path
                d="M5 1.5H1.5C0.947715 1.5 0.5 1.94772 0.5 2.5V10.5C0.5 11.0523 0.947715 11.5 1.5 11.5H9.5C10.0523 11.5 10.5 11.0523 10.5 10.5V7"
                stroke={color}
            />
            <path
                d="M4.63033 5.25053L4.27678 7.7254L6.75165 7.37185M4.63033 5.25053L8.16586 1.71499M4.63033 5.25053L6.75165 7.37185M6.75165 7.37185L10.2872 3.83632M8.16586 1.71499L8.87297 1.00789C9.2635 0.617364 9.89666 0.617364 10.2872 1.00789L10.9943 1.71499C11.3848 2.10552 11.3848 2.73868 10.9943 3.12921L10.2872 3.83632M8.16586 1.71499L10.2872 3.83632"
                stroke={color}
            />
        </SVG>
    );
};

EditIcon.propTypes = {
    $style: PropTypes.object,
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default EditIcon;
